import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Form, Formik, useFormik} from 'formik'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import * as auth from '../redux/actions'
import {useDispatch, useSelector} from 'react-redux'
import {Link, Route, Switch, useHistory} from 'react-router-dom'
import {EmailSuccess} from './EmailSuccess'
import axios from 'axios'
import {toast} from 'react-toastify'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

const emailSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

export function ForgotPassword() {
  const history = useHistory()
  const dispatch = useDispatch()
  const authResp = useSelector((state: any) => state.auth)
  const loading = authResp?.loading
  const success = authResp?.success
  const responseMessage = authResp.data?.response?.data?.data?.message
  const [emailId, setEmailId] = useState('')
  const [googleReCaptchaKey, setGoogleReCaptchaKey] = useState('')

  useEffect(() => {
    axios.get(API_URL + '/frontend/key-setting?name=Recaptcha_Client_V3').then((res) => {
      setGoogleReCaptchaKey(res.data.data.key)
    })
  }, [])

  useEffect(() => {
    if (!googleReCaptchaKey) return
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${googleReCaptchaKey}`
    script.async = true
    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [googleReCaptchaKey])

  const executeCaptcha = (): Promise<string> =>
    new Promise((resolve, reject) => {
      ;(window as any).grecaptcha.ready(async () => {
        try {
          const token = await (window as any).grecaptcha.execute(googleReCaptchaKey, {
            action: 'forgot_password',
          })
          resolve(token)
        } catch (err) {
          reject(err)
        }
      })
    })

  useEffect(() => {
    if (success) {
      history.push({
        pathname: '/auth/success',
        state: {email: emailId, message: responseMessage},
      })
    }
  }, [success])

  return (
    <>
      <h4 className='login-box-msg text-center mt-10 mb-3' data-cy='forgot-password-heading'>
        Forgotten Password ?
      </h4>
      <Formik
        initialValues={{}}
        validationSchema={emailSchema}
        onSubmit={async (values: {[key: string]: string}, {setSubmitting}) => {
          try {
            const captchaToken = await executeCaptcha()
            setEmailId(values.email)
            dispatch(auth.actions.forgotPassword(values.email, captchaToken))
          } catch (err) {
            toast.error('CAPTCHA verification failed. Please try again.')
          } finally {
            setSubmitting(false)
          }
        }}
        data-cy='forgot-password-form'
      >
        {({isSubmitting, touched, handleChange, errors, values, setFieldValue}) => (
          <Form>
            <div className='pt-8'>
              <div className=''>
                <FormTextBox
                  labelClassName='col-md-12'
                  containerClassName='col-md-12'
                  type='email'
                  placeholder='Email'
                  name='email'
                  label='Email'
                  onChange={handleChange}
                  errors={errors}
                  touched={touched}
                  required={true}
                  data-cy='forgot-password-email-field'
                />
              </div>

              <div className=''>
                <div className=''>
                  <button
                    type='submit'
                    className='btn btn-lg w-100 mb-5'
                    disabled={loading}
                    data-cy='forgot-password-submit-button'
                  >
                    {!loading && <span className='indicator-label'>Submit</span>}

                    {loading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  <div className='text-center mb-5'>
                    <Link
                      to='/auth/login'
                      className='login-link fs-6 fw-bolder'
                      data-cy='forgot-password-login-link'
                    >
                      Go back
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
